import { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Form, InputGroup, Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";

const IS_DEV = process.env.REACT_APP_DEV === "true";

/**
 * @param {{
 *   data: any[];
 *   headers: { key: string; label: string }[];
 *   isProblematic?: (row: any) => boolean;
 *   focusedRowId?: string | null;
 *   rowDomId?: (row: any) => string;
 * }} props
 */
export default function EditableTable({
  data,
  headers,
  isProblematic,
  focusedRowId,
  rowDomId,
}) {
  const [tableData, setTableData] = useState([]);
  const [show, setShow] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleSave = async ({
    id,
    icps,
    packageCode,
    hasMarking,
    packages,
    commissionTIN,
    ownerType,
    ...payload
  }) => {
    if (IS_DEV) {
      toast.success("DEV: сохранено локально (без запроса).");
      return;
    }
    try {
      const data = await axios.post(
        `https://api-poster.uzpos.uz/api/set-entity-extras`,
        {
          token: localStorage.getItem("apiToken"),
          id: id.split("-")[0],
          ...(id.split("-")[1]
            ? {
                [id.split("-")[1]]: JSON.stringify({
                  icps: icps,
                  packageCode: packageCode,
                  hasMarking: hasMarking,
                  packages: JSON.stringify(packages),
                  commissionTIN: commissionTIN,
                  ownerType: ownerType,
                }),
                ...payload,
              }
            : {
                icps: icps,
                packageCode: packageCode,
                hasMarking: hasMarking,
                packages: JSON.stringify(packages),
                commissionTIN: commissionTIN,
                ownerType: ownerType,
              }),
        },
      );
    } catch (err) {
      toast.error("Сохранение не выполнено.");
    }
  };

  const openModal = (row) => {
    setActiveRow({ ...row });
    setSearchResults([]);
    setShow(true);
  };

  const searchIcps = async () => {
    if (!activeRow.icps) return;
    const { data } = await axios
      .get(
        `https://tasnif.soliq.uz/api/cl-api/integration-mxik/get/information?page=0&size=25&mxikCode=${activeRow.icps}&type=1`,
      )
      .catch((e) => ({
        data: null,
      }));

    if (!data) toast.error("МХИК не найден.");
    setSearchResults(data?.data || []);
  };

  const handleModalSave = async () => {
    setTableData((prev) =>
      prev.map((row) => (row.id === activeRow.id ? { ...activeRow } : row)),
    );

    await handleSave(activeRow);
    setShow(false);
  };

  return (
    <>
      <table className="custom-table">
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h.key}>{h.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row) => (
            <tr
              key={row.id}
              id={rowDomId ? rowDomId(row) : undefined}
              className={[
                isProblematic?.(row) ? "catalog-row--problematic" : "",
                focusedRowId != null && focusedRowId === row.id
                  ? "catalog-row--problematic-focus"
                  : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <td>{row.id}</td>
              <td>{row.name}</td>
              <td>{row.icps || "--"}</td>
              <td>
                {row?.packages
                  ? row.packages.find(
                      (e) => String(e.code) === row?.packageCode,
                    )?.nameUz ||
                    row?.packageCode ||
                    "--"
                  : row?.packageCode || "--"}
              </td>
              <td>
                <label className="switch">
                  <input type="checkbox" checked={row.hasMarking} disabled />
                  <span className="slider" />
                </label>
              </td>
              <td>
                <div className="actions">
                  <Button
                    style={{
                      backgroundColor: "#3c8490",
                      borderColor: "#3c8490",
                    }}
                    onClick={() => openModal(row)}
                  >
                    Ред.
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* MODAL */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ред.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activeRow && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>МХИК</Form.Label>
                <InputGroup>
                  <Form.Control
                    value={activeRow.icps || ""}
                    onChange={(e) =>
                      setActiveRow({ ...activeRow, icps: e.target.value })
                    }
                  />
                  <Button variant="primary" onClick={searchIcps}>
                    Поиск
                  </Button>
                </InputGroup>
              </Form.Group>

              {searchResults.length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label>Search Results</Form.Label>
                  {/* <Dropdown>
                    <Dropdown.Toggle variant="secondary">
                      Выберите...
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {searchResults.map((res) => (
                        <Dropdown.Item
                          key={res.mxik}
                          onClick={setActiveRow({
                            ...activeRow,
                            packages: res?.packages,
                          })}
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          <div>
                            <strong>{res.name}</strong>
                            <div className="text-muted">IKPU: {res.mxik}</div>
                          </div>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown> */}
                  <Form.Select
                    onChange={(e) =>
                      setActiveRow({
                        ...activeRow,
                        packages: JSON.parse(e.target.value),
                      })
                    }
                  >
                    <option>Выберите...</option>
                    {searchResults.map((res) => (
                      <option
                        key={res.mxik}
                        value={JSON.stringify(res.packages)}
                      >
                        {res.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Условная единица</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setActiveRow({
                      ...activeRow,
                      packageCode: e.target.value,
                    });
                  }}
                >
                  <option>Выберите...</option>
                  {activeRow.packages?.map((p) => (
                    <option key={p.code} value={p.code}>
                      {p.nameUz}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Тип владения</Form.Label>
                <Form.Select
                  value={activeRow?.ownerType || 0}
                  onChange={(e) =>
                    setActiveRow({ ...activeRow, ownerType: e.target.value })
                  }
                >
                  <option value={0}>покупает и продает</option>
                  <option value={1}>произвел сам</option>
                  <option value={2}>обслуживающий</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Комитент ИНН/ПИНФЛ</Form.Label>
                <InputGroup>
                  <Form.Control
                    value={activeRow.commissionTIN || ""}
                    onChange={(e) =>
                      setActiveRow({
                        ...activeRow,
                        commissionTIN: e.target.value,
                      })
                    }
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group>
                <Form.Check
                  type="checkbox"
                  label="Подлежит маркировке"
                  checked={activeRow.hasMarking}
                  onChange={(e) =>
                    setActiveRow({ ...activeRow, hasMarking: e.target.checked })
                  }
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Отмена
          </Button>
          <Button variant="success" onClick={handleModalSave}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
